import { useState } from "react";
import { SocialIcon } from "components/UI/SocialIcon";
import { LINK_REGEXP } from "./constants";
import "./styles/SocialLinkItem.scss";

interface ILinkType {
  name?: null | string;
  isRequired?: boolean;
  socialKey?: string;
}

const validateUrl = (url: string) => {
  let isValidKey: ILinkType = { name: null, isRequired: false };

  for (const [key, { regExp, isRequired, socialKey }] of Object.entries(LINK_REGEXP)) {
    if (regExp.test(url)) {
      isValidKey = {
        name: key,
        isRequired,
        socialKey
      };
    }
  }

  return isValidKey;
};

export const SocialLinkItem = ({ value, id, name, validMessage, updateInput, removeInput }: any) => {
  const [iconType, setIconType] = useState<string | null>(name);

  const handleRemove = () => {
    removeInput(id);
  };

  const handleUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const { name = null, isRequired = false, socialKey } = validateUrl(value);
    const validMessage = name || !value.length ? null : "Please enter valid link";
    const dataToUpdate = {
      value,
      name,
      validMessage,
      isRequired,
      socialKey
    };

    setIconType(name);
    updateInput(id, dataToUpdate);
  };

  const renderError = () => {
    if (!validMessage) {
      return null;
    }

    return (
      <div className="SocialLinkItem-Error">
        {validMessage}
      </div>
    );
  };

  return (
    <div className="SocialLinkItem">
      <div className="SocialLinkItem-InputWrap">
        <div className="SocialLinkItem-IconWrap">
          {iconType && <SocialIcon name={iconType} />}
        </div>
        <input
          id={id}
          onChange={handleUpdate}
          value={value}
          name={name}
          className="SocialLinkItem-Input"
          type="url"
          placeholder="https://yoursite.com/name"
        />
        <button className="SocialLinkItem-Remove" onClick={handleRemove}>
          <span></span>
        </button>
      </div>
      {renderError()}
    </div>
  );
};
